// client/src/App.tsx
import React, { useState, useEffect, useRef } from 'react';
//import './App.css';
import { Server } from 'http';

const SSE_URL = process.env.REACT_APP_SSE_URL || "DEFINE_SSE_URL"; // + "/members/login"; 'http://localhost:3001/events'; // Our SSE endpoint


type MyProps = {
    setClientName: (name: string) => void;
    addNewLeadViaWebhook: (name: string) => void;
};
//function ServerEvent() {

  const ServerEvent: React.FC<MyProps> = ({ setClientName, addNewLeadViaWebhook }) => {

  const [messageHistory, setMessageHistory] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState('');
  const [isConnected, setIsConnected] = useState(false);

  // Using useRef to hold the EventSource instance, so it persists across renders
  const eventSourceRef = useRef<EventSource | null>(null);

  useEffect(() => {
    // 1. Establish SSE connection
    if (!eventSourceRef.current) { // Only create if not already exists
      const eventSource = new EventSource(SSE_URL);
      eventSourceRef.current = eventSource; // Store it in ref

      eventSource.onopen = () => {
        console.log('Connected to SSE stream');
        setIsConnected(true);
      };

      // Listen for generic 'message' events (if no 'event:' field is specified by server)
      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          console.log('data::', JSON.stringify(data));
          addNewLeadViaWebhook(data.name); 

          setMessageHistory((prev) => prev.concat(`[${data.name || 'message'}]: ${data.message || event.data}`));
        } catch (e) {
          // If it's not JSON, just add the raw data
          //console.error(`Error parsing SSE message:${e}`);
          //setMessageHistory((prev) => prev.concat(`[raw]: ${event.data}`));
        }
      };

      // Listen for a custom 'broadcast' event (if the server sends 'event: broadcast')
      // Note: Our current server sends data with 'type: broadcast' in the JSON,
      // but if the server also included `event: broadcast\n` this would catch it specifically.
      // For this example, `onmessage` handles all.
      /*
      eventSource.addEventListener('broadcast', (event) => {
        try {
          const data = JSON.parse(event.data);
          setMessageHistory((prev) => prev.concat(`[BROADCAST]: ${data.content}`));
        } catch (e) {
          setMessageHistory((prev) => prev.concat(`[BROADCAST raw]: ${event.data}`));
        }
      });
      */

      eventSource.onerror = (error) => {
        console.error('EventSource failed:', error);
        setIsConnected(false);
        // The browser's EventSource API handles auto-reconnection by default.
        // You can inspect `error.eventPhase` to see if it's a network error.
        // `eventSource.close()` can be called here if you want to stop reconnections.
      };
    }

    // Clean up on component unmount
    return () => {
      if (eventSourceRef.current) {
        console.log('Closing SSE connection...');
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
    };
  }, []); // Empty dependency array means this runs once on mount


  return (
    <div className="App">
      <header className="App-header">

        <p style={{display: 'none'}}>SSE Connection Status: {isConnected ? 'Connected' : 'Disconnected'}</p>

        <div style={{ display: 'none', border: '1px solid #ccc', padding: '15px', width: '200%', minHeight: '200px', overflowY: 'auto', textAlign: 'left' }}>
          <h2>Messages:</h2>
          {messageHistory.length === 0 ? (
            console.log('No messages history yet'),
            <p>No messages yet.</p>
          ) : (
            <ul>
              {messageHistory.map((message, index) => (
                console.log('message::', message),
                <li key={index} style={{ marginBottom: '5px' }}>{message}</li>
              ))}
            </ul>
          )}
        </div>
      </header>
    </div>
  );
}

export default ServerEvent;